import styled from "styled-components"
import { device } from "breakpoints"
import { MainColumn } from "../MainColumn"
import { getGradient } from "helpers/getGradient"

import { FlexGrid, FlexRow, FlexCol } from "../FlexGrid"

export const NewFlexGrid = styled(FlexGrid)`
  width: 100% !important;
`
export const NewFlexRow = styled(FlexRow)``
export const NewFlexCol = styled(FlexCol)`
  margin-bottom: 45px !important;
  position: relative;
  :before {
    content: "";
    position: absolute;
    top: 8px;
    left: 0;
    width: 1px;
    height: 100%;
    background-image: linear-gradient(
      180deg,
      #d2d4e0 2%,
      rgba(210, 212, 224, 0) 100%
    );
  }
  :nth-child(3n) {
    :before {
      display: none;
    }
  }
  :after {
    content: "";
    position: absolute;
    top: -25px;
    left: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      180deg,
      #d2d4e0 2%,
      rgba(210, 212, 224, 0) 100%
    );
  }
  :first-child,
  :nth-child(2) {
    ::after {
      display: none;
    }
  }
  @media ${device.tablet} {
    ::after {
      display: none;
    }
    :nth-child(3n) {
      :before {
        display: block;
      }
    }
  }
  @media ${device.large} {
    position: relative;
    ::before {
      content: "";
      position: absolute;
      top: 5px;
      left: 0;
      height: 100%;
      width: 1px;
      background-image: linear-gradient(
        180deg,
        #d2d4e0 2%,
        rgba(210, 212, 224, 0) 100%
      );
    }
  }

  :first-child {
    :before {
      display: none;
    }
  }
`
export const Container = styled.div`
  background-color: #f6f8fa;
  position: relative;
  margin: ${props => `${props.theme.componentMargin.mobile}px auto`};
  padding-top: ${props => `${props.theme.componentMargin.mobile}px`};
  padding-bottom: 50px;

  @media (min-width: 500px) {
    padding-bottom: 70px;
  }

  @media ${device.tablet} {
    margin-top: 0;
  }
  @media ${device.desktop} {
    margin: ${props => `0 auto ${props.theme.componentMargin.desktop}px auto`};
    padding-top: ${props => `${props.theme.componentMargin.desktop}px`};
    padding-bottom: 150px;
  }

  @media ${device.large} {
    margin: ${props => `0 auto ${props.theme.componentMargin.large}px auto`};
    padding-top: ${props => `${props.theme.componentMargin.large}px`};
    padding-bottom: 240px;
  }

  @media ${device.big} {
    padding-bottom: 280px;
  }

  :after {
    content: "";
    position: absolute;
    height: 1px;
    width: 100vw;
    left: calc(50%);
    bottom: 0px;
    transform-origin: 50%;
    background-image: ${props => getGradient(props.theme.site)};
    transform: skewY(4deg) translateX(-50%);

    @media ${device.tablet} {
      bottom: -40px;
      transform: skewY(+6deg) translateX(-50%);
    }

    @media ${device.desktop} {
      bottom: -32px;
      transform: skewY(5deg) translateX(-50%);
    }

    @media ${device.large} {
      bottom: -40px;
      transform: skewY(5deg) translateX(-50%);
    }
  }
`
export const Title = styled.h3`
  font-weight: 700;
  font-size: 36px;
  color: #000000;
  letter-spacing: -0.5px;
  text-align: center;
  line-height: 36px;
  margin-bottom: 24px;

  @media ${device.tablet} {
    margin-bottom: 35px;
  }
  @media ${device.large} {
    font-size: 48px;
    letter-spacing: -0.5px;
    line-height: 42px;
    margin-bottom: 70px;
  }
`

export const GraphTitle = styled.h5`
  font-weight: 600;
  font-size: 15px;
  color: #000000;
  letter-spacing: -0.25px;
  text-align: center;
  line-height: 28px;
  text-transform: capitalize;

  @media ${device.desktop} {
    font-size: 22px;
  }
  @media ${device.large} {
    font-size: 24px;
    margin-bottom: 14px;
  }
`
export const GraphItemContainer = styled.div`
  width: 100%;
`

export const NewMainColumn = styled(MainColumn)`
  width: calc(100% - 2 * 20px);
  @media ${device.desktop} {
    width: calc(100% - 2 * 45px);
  }
`
